export const c_multiple_file_upload_m_horizontal_GridTemplateColumns = {
  "name": "--pf-c-multiple-file-upload--m-horizontal--GridTemplateColumns",
  "value": "fit-content(100%)",
  "var": "var(--pf-c-multiple-file-upload--m-horizontal--GridTemplateColumns)"
};
export default c_multiple_file_upload_m_horizontal_GridTemplateColumns;